import React from 'react';
import Button from '../Button';
import './Hero.css';
import img from '../../img/narod.png';

const Hero = ({ onLearnMoreClick }) => {
  return (
    <section className="hero" id="start">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-spacer"></div>
          
          <div className="hero-text">
            <h1 className="hero-title">"БЕЛАЯ"</h1>
            <p className="hero-subtitle">гостиница</p>
            <p className="hero-description">
              Проживание и другие услуги для иностранных граждан в Уфе
            </p>
          </div>
          
          <div className="hero-spacer-small"></div>
          <div className="hero-spacer-xs"></div>
          
          <div className="hero-image">
            <img src={img} alt="Народный стиль" />
          </div>
          
          <Button onClick={onLearnMoreClick} variant="primary">
            ПОДРОБНЕЕ
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;